import React from 'react';
import styles from './NewsIcons.module.scss';
import { useRecoilValue } from 'recoil';
import { assetPathFnState } from '../../recoil/atoms';
import { isMobileState } from '../../recoil/selectors';
import { Link } from '../../root/components/Link';

export const NewsIcons: React.FC = () => {
  const assetPathFn = useRecoilValue(assetPathFnState);
  const isMobile = useRecoilValue(isMobileState);

  return (
    <div className={styles.newsIconsFeaturedIn}>
      <Link
        dataTrackLabel="New York Times"
        dataTrackLocation="Product News Icons"
        target="_blank"
        href="https://www.nytimes.com/2019/10/15/style/spanx-shapewear-brands.html"
      >
        <img src={assetPathFn('news_icon_nytimes.svg')} alt="new york times" style={isMobile ? { maxHeight: 28 } : {}} />
      </Link>
      <Link
        dataTrackLabel="Forbes"
        dataTrackLocation="Product News Icons"
        target="_blank"
        href="https://www.forbes.com/sites/cherylrobinson/2022/04/13/how-a-300-thousand-kickstarter-turned-into-a-13-million-series-a-funding-round-for-honeylove/"
      >
        <img
          src={assetPathFn('news_icon_forbes_280x.png')}
          alt="cosmopolitan"
          style={isMobile ? { maxHeight: 36, filter: 'brightness(1.1)' } : { maxHeight: 60, filter: 'brightness(1.1)' }}
        />
      </Link>
      <Link
        dataTrackLabel="Good Morning America"
        dataTrackLocation="Product News Icons"
        target="_blank"
        href="https://www.goodmorningamerica.com/living/story/purchasing-social-media-ads-76691317"
      >
        <img
          src={assetPathFn('news_icon_goodmonringamerica.png')}
          alt="good morning america"
          style={isMobile ? { maxHeight: 40, marginTop: 12 } : { maxHeight: 80 }}
        />
      </Link>
      <Link
        dataTrackLabel="Elle"
        dataTrackLocation="Product News Icons"
        target="_blank"
        href="https://www.elle.com/culture/a27718722/serena-williams-first-athlete-forbes-richest-self-made/"
      >
        <img src={assetPathFn('news_icon_elle.png')} alt="elle" style={isMobile ? { maxHeight: 28 } : {}} />
      </Link>
      <Link
        dataTrackLabel="Brides"
        dataTrackLocation="Product News Icons"
        target="_blank"
        href="https://www.brides.com/best-shapewear-for-wedding-dresses-4796832"
      >
        <img src={assetPathFn('news_icon_brides.svg')} alt="brides" style={isMobile ? { maxHeight: 28 } : {}} />
      </Link>
    </div>
  );
};

export default NewsIcons;
